import {
  FarmtrxIconHardware,
  FarmtrxIconHarvesterCombine,
  FarmtrxIconUsers,
  FarmtrxIconCrop,
  FarmtrxIconSettings,
} from '@farmtrx/farmtrx-icons'
import { useTranslation } from 'react-i18next'
import FeatureFlagsContext from 'context/feature-flags-context'
import { Box, Divider } from '@mui/material'
import { Navigate, Route, Routes } from 'react-router'
import { CommonSidebar, CommonSidebarLink } from '../common-sidebar'
import CropsComponent from './crops'
import EquipmentsComponent from './equipment'
import HardwareComponent from './hardware'
import CropHeadersComponent from './headers'
import UserAccountsComponent from './user-accounts'
import CropLegend from './crop-legend'
import PreferencesComponent from 'components/admin/preferences'
import Operators from './operators'
import { useDispatch } from 'react-redux'
import { useEffect, useContext } from 'react'
import { getUserList } from 'api/user'
import FeatureFlag from 'components/feature-flag'
import { fetchOperators } from 'api/operator'
import { get } from 'es-toolkit/compat'
import { TEST_IDS } from 'test-ids'
import { FEATURE_FLAGS } from 'feature-flags'

export default function FarmSettings() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const features = useContext(FeatureFlagsContext)
  // If the feature flag is not found, is is disabled by default
  const operators = get(features, FEATURE_FLAGS.operators, {
    isEnabled: false,
  })

  useEffect(() => {
    dispatch(getUserList())
    dispatch(fetchOperators())
  }, [])

  return (
    <Box
      sx={{
        width: 1,
        display: 'flex',
        overflowY: 'auto',
      }}
    >
      <CommonSidebar testId={TEST_IDS.farmSettingsSidebar}>
        <CommonSidebarLink
          to="../hardware"
          icon={<FarmtrxIconHardware title={t('hardware')} />}
          label={t('hardware')}
          testId={TEST_IDS.farmSettingsHardwareNav}
        />
        <Divider />
        <CommonSidebarLink
          to="../combines"
          icon={<FarmtrxIconHarvesterCombine title={t('combines')} />}
          label={t('combines')}
          testId={TEST_IDS.farmSettingsCombinesNav}
        />
        <Divider />
        <CommonSidebarLink
          to="../headers"
          icon={<FarmtrxIconHarvesterCombine title={t('headers')} />}
          label={t('headers')}
          testId={TEST_IDS.farmSettingsHeadersNav}
        />
        <Divider />
        <CommonSidebarLink
          to="../userAccounts"
          icon={<FarmtrxIconUsers title={t('user_accounts')} />}
          label={t('user_accounts')}
          testId={TEST_IDS.farmSettingsUserAccountsNav}
        />
        <Divider />
        <FeatureFlag featureName={FEATURE_FLAGS.operators}>
          <CommonSidebarLink
            key="operators"
            to="../operators"
            icon={<FarmtrxIconUsers title={t('operators')} />}
            label={t('operators')}
            testId={TEST_IDS.farmSettingsOperatorsNav}
          />
          <Divider />
        </FeatureFlag>
        <CommonSidebarLink
          to="../crops"
          icon={<FarmtrxIconCrop title={t('crops_varieties')} />}
          label={t('crops_varieties')}
          testId={TEST_IDS.farmSettingsCropsNav}
        />
        <Divider />
        <CommonSidebarLink
          to="../cropLegends"
          icon={<FarmtrxIconCrop title={t('legends')} />}
          label={t('legends')}
          testId={TEST_IDS.farmSettingsCropLegendsNav}
        />
        <Divider />
        <CommonSidebarLink
          key="preferences"
          to="../preferences"
          icon={<FarmtrxIconSettings title={t('preferences')} />}
          label={t('preferences')}
          testId={TEST_IDS.farmSettingsPreferencesNav}
        />
        <Divider />
      </CommonSidebar>
      <Routes>
        <Route
          exact
          path="/"
          element={<Navigate to="/farmSetup/hardware" replace={true} />}
        />

        <Route path="/crops" element={<CropsComponent />} />
        <Route path="/cropLegends" element={<CropLegend />} />
        <Route path="/headers" element={<CropHeadersComponent />} />
        <Route path="/combines" element={<EquipmentsComponent />} />
        <Route path="/hardware" element={<HardwareComponent />} />
        <Route path="/userAccounts" element={<UserAccountsComponent />} />
        <Route path="/preferences" element={<PreferencesComponent />} />

        {operators.isEnabled && (
          <Route path="/operators" element={<Operators />} />
        )}
      </Routes>
    </Box>
  )
}
